import * as ACTIONS from '../../actionTypes/priceMatrixActionTypes';

const initialState = {
  packageDataInitialized: false,
  invalidInput: false,
};

function appStatus(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.INIT_SUCCESS:
      return {
        ...state,
        packageDataInitialized: true,
      };
    case ACTIONS.INIT_FAIL:
      return {
        ...state,
        invalidInput: true,
        packageDataInitialized: true,
      };
    default:
      return state;
  }
}

export default appStatus;
